import Store from "../store/store";
import CartItem from "../classes/CartItem";

export default class BeatTapes {
    constructor(beatTapesData) {

        for (const i in beatTapesData) {
            this[i] = beatTapesData[i];
        }

        this.title = this.name;
        this.user = Store.state.user;
        this.itemId = this.getRandomId();
    }


    static makeArray(kitsData) {
        return kitsData.map(kit => new BeatTapes(kit));
    }

    image(size = 100) {
        if (this.artwork && this.artwork.files) {
            return this.artwork.files[size];
        }
        return this.user.avatar.files[size];
    }

    addToCart() {
        Store.state.cart.addItem(new CartItem(this, null, this.price, this.getType()))
    }

    inCart(productPricing = null) {
        return Store.state.cart.inCart(this);
    }

    play () {
        if (Store.state.playlistManager.isPlaying(this)) {
            Store.state.playlistManager.resume(this)
        } else {
            Store.state.playlistManager.setPagePlaylistToCurrent()
            Store.state.playlistManager.play(this)
        }
    }

    pause () {
        Store.state.playlistManager.pause()
    }

    getType() {
        return "beattapes";
    }

    shareUrl() {
        return `${ab.baseUrl}/beat-tapes/${this.id}`;
    }

    minPrice() {
        return this.price;
    }

    maxPrice() {
        return this.price;
    }

    playTag() {
        return false;
    }

    isBeat() {
        return false;
    }

    isSong() {
        return false;
    }

    isSoundKit() {
        return false;
    }

    isCollection() {
        return true;
    }

    getRandomId() {
        let number = Math.random();
        number.toString(36);
        return number.toString(36).substr(2, 9);
    }

    notPlayable() {
        return true
    }
}